import React, { useState, useEffect } from "react";
import axios from "axios";
import NavBar from "../navigationBar/NavBar";
import { ipAddress } from "../../address";
import DeleteConfirmationModal from "../contact/DeleteConfirmationModal";
import UserModal from "../users/userModal";

function ViewMyProfile() {
  const [jobs, setJobs] = useState("");
  const [spinner, setSpinner] = useState(true);

  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);

  const [deleteJobId, setDeleteJobId] = useState(null);

  const openDeleteConfirmationModal = (event, id) => {
    event.preventDefault();
    setDeleteJobId(id);
    setIsDeleteConfirmationOpen(true);
  };

  const closeDeleteConfirmationModal = () => {
    setIsDeleteConfirmationOpen(false);
    setDeleteJobId(null);
  };

  const handleDelete = () => {
    axios
      .post(ipAddress + "/api/deletejob", {
        jobId: deleteJobId,
      })
      .catch((error) => {
        console.log(error);
      });

    closeDeleteConfirmationModal();
    window.location.reload();
  };

  useEffect(() => {
    axios
      .post(ipAddress + "/api/getuseruploadedjobs", {
        userId: window.localStorage.getItem("userId"),
      })
      .then((response) => {
        setJobs(response.data);
      })
      .catch((error) => {
        console.log("You have not uploaded any jobs");
      });
    setSpinner(false);
  }, []);

  return (
    <div className="profile">
      <link rel="stylesheet" href="profile.css"></link>
      <link rel="stylesheet" href="RegisterJob.css"></link>

      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css"
      ></link>
      {<NavBar />}

      <br />
      {spinner === true ? (
        <ul id="jobs-list">
          <span className="spinner">
            <i className="fa-solid fa-spinner"></i>
          </span>
        </ul>
      ) : (
        <UserModal
          filteredUsers={jobs}
          openDeleteConfirmationModal={openDeleteConfirmationModal}
        />
      )}

      {deleteJobId && (
        <div
          className={`modal-overlay ${
            isDeleteConfirmationOpen ? "show" : "hide"
          }`}
        >
          <div
            className={`modal-content ${
              isDeleteConfirmationOpen ? "show" : "hide"
            }`}
          >
            <DeleteConfirmationModal
              closeDeleteConfirmationModal={closeDeleteConfirmationModal}
              handleDelete={handleDelete}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewMyProfile;
